import { render, staticRenderFns } from "./FigmaLayerSelector.vue?vue&type=template&id=68ed127f"
import script from "./FigmaLayerSelector.vue?vue&type=script&lang=js"
export * from "./FigmaLayerSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports